import { render, staticRenderFns } from "./CustomerComplaintVerification.vue?vue&type=template&id=f0fffc7a&"
import script from "./CustomerComplaintVerification.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports